/* eslint-disable camelcase */
import ufeApi from 'services/api/ufeApi';
import Empty from 'constants/empty';

const HANDOFF_SUMMARY_URL = '/gway/v1/ucm/customer/handoff-summary';
const HANDOFF_SUMMARY_TYPE = 'HANDOFF_SUMMARY';
const HANDOFF_SUMMARY_TITLE = 'Handoff Summary from AI Beauty Chat!';
const HANDOFF_SOURCE_NAME = 'AIBC';

/**
 * Sends the AI Beauty Chat handoff summary to UCM so the live agent picks up the conversation
 * with context. Auth/session is handled by ufeApi (no manual Cookie/Authorization headers).
 *
 * @param {Object} params
 * @param {Object} params.data - The GLADLY_HANDOFF frame's `data` payload.
 * @param {string} params.aibcConversationId - The AIBC (SuperChat) conversation/session id.
 * @param {string} params.clientId - The shopper's BI account id.
 * @param {string} [params.email] - The shopper's email (may be empty).
 * @returns {Promise<Object>} Resolves with the UCM response; rejects on an error response.
 */
function postHandoffSummary({ data = Empty.Object, aibcConversationId, clientId, email = '' }) {
    const headers = {
        'Content-Type': 'application/json'
    };

    const payload = JSON.stringify({
        content: {
            type: HANDOFF_SUMMARY_TYPE,
            title: HANDOFF_SUMMARY_TITLE,
            body: data.chat_summary || '',
            clientId: clientId || data.client_id || '',
            email: email || '',
            aibcConversationId: aibcConversationId || '',
            chat_history: [{}],
            sourceName: HANDOFF_SOURCE_NAME,
            expandByDefault: true
        }
    });

    return ufeApi
        .makeRequest(HANDOFF_SUMMARY_URL, {
            method: 'POST',
            body: payload,
            headers
        })
        .then(res => (res?.errorCode ? Promise.reject(res) : res));
}

export default postHandoffSummary;
